import { ACTION } from './ballast_actions';

const initialState = {
  brandList: [],
  typeList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST_BALLAST_BRAND}_FULFILLED`:
      return {
        ...state,
        brandList: action.payload,
      };
    case `${ACTION.LIST_BALLAST_TYPE}_FULFILLED`:
      return {
        ...state,
        typeList: action.payload,
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/redux/references/ballast_reducer.js